import generatePassword from "omgopass";

export function randomPassword() {
  return generatePassword({
    hasNumbers: true,
    titlecased: true,
    separators: "_-$",
    syllablesCount: 5,
    minSyllableLength: 4,
    maxSyllableLength: 6,
  });
}
